<template>
  <div>
    <v-data-table :headers="headers" :items="values" class="elevation-1">
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Values</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="mb-2" v-bind="attrs" v-on="on">Add Value</v-btn>
            </template>
            <v-card>
              <validation-observer v-slot="{ handleSubmit }">
                <form @submit.prevent="handleSubmit(saveValue)">
                  <v-card-title class="headline grey lighten-2" primary-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="6">
                          <validation-provider
                            :vid="uuid()"
                            name="Value"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <v-text-field
                              label="Value"
                              v-model="editedValue.value"
                            ></v-text-field>
                            <span class="validation-message">{{
                              errors[0]
                            }}</span>
                          </validation-provider>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="resetDialog()"
                      >Cancel</v-btn
                    >
                    <v-btn color="blue darken-1" text type="submit">Save</v-btn>
                  </v-card-actions>
                </form>
              </validation-observer>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="editValue(item)">mdi-pencil</v-icon>
        <v-icon small @click="deleteValue(item)">mdi-delete</v-icon>
      </template>
    </v-data-table>

    <v-row>
      <v-col cols="6">
        <v-select
          label="Initial Value"
          :items="dataType.baseType.values"
          v-model="dataType.initialValue"
          @change="save"
        ></v-select>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { find, findIndex, map, isUndefined } from "lodash";
import uuid from "src/mixins/uuid";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  name: "DataTypeEnumerated",
  props: ["tempId"],
  components: { ValidationProvider, ValidationObserver },
  mixins: [uuid],
  data() {
    return {
      dialog: false,
      headers: [
        {
          text: "Value",
          sortable: false,
          value: "value",
        },
        { text: "Actions", value: "actions", sortable: false },
      ],
      editedValue: {},
    };
  },
  computed: {
    dataType() {
      return find(this.$store.state.dataTypes, { tempId: this.tempId });
    },
    values() {
      return map(this.dataType.baseType.values, (value) => ({
        tempId: this.uuid(),
        value,
      }));
    },
    formTitle() {
      return this.editedValue.tempId ? "Update Value" : "Add Value";
    },
  },
  methods: {
    resetDialog() {
      this.dialog = false;
      this.editedValue = {};
    },
    editValue(value) {
      this.editedValue = value;
      this.dialog = true;
    },
    saveValue() {
      const { tempId, value } = this.editedValue;

      if (tempId) {
        const index = findIndex(this.values, { tempId });
        this.values.splice(index, 1, { tempId, value });
        this.$store.dispatch("updateDataType", {
          ...this.dataType,
          baseType: {
            ...this.dataType.baseType,
            values: this.values.map(({ value }) => value),
          },
        });
      } else {
        if (isUndefined(this.dataType.baseType.values)) {
          this.dataType.baseType.values = [];
        }

        this.dataType.baseType.values.push(value);
        this.$store.dispatch("updateDataType", this.dataType);
      }

      this.resetDialog();
    },
    async deleteValue({ tempId }) {
      if (await this.$confirm("Are you sure you want to delete this value?")) {
        const index = findIndex(this.values, { tempId });
        this.values.splice(index, 1);
        this.$store.dispatch("updateDataType", {
          ...this.dataType,
          baseType: {
            ...this.dataType.baseType,
            values: this.values.map(({ value }) => value),
          },
        });
      }
    },
    save() {
      this.$store.dispatch("updateDataType", this.dataType);
    },
  },
};
</script>
